import * as React from "react";

import {PageDisplayContext} from "./page-display-container.tsx";
import type {PartialPageSettings} from "./page-settings.ts";

type Props = {
    // The optional children.
    // If used, it accepts element(s) that are rendered inside this component.
    children?: React.ReactNode;
    // Page settings to be updated.
    settings: PartialPageSettings;
    // Whether we want to reset page settings. Defaults true.
    resetSettings: boolean;
};

type DefaultProps = {
    resetSettings: Props["resetSettings"];
};

/**
 * The PageDisplay component is used to set/write the values that subsequent
 * PageDisplayProvider components will consume to obtain the data. PageDisplay
 * exposes a settings prop to set new values needed in a specific page.
 *
 * @example
 * <PageDisplay settings={{footer: false, headerBackgroundColor: "white"}}>
 *  <About {...props} />
 * </PageDisplay>
 */
export default class PageDisplay extends React.PureComponent<Props> {
    static defaultProps: DefaultProps = {
        resetSettings: true,
    };

    render(): React.ReactNode {
        const {children, settings, resetSettings} = this.props;
        return (
            <PageDisplayContext.Consumer>
                {({update}) => {
                    update(settings, resetSettings);
                    return children;
                }}
            </PageDisplayContext.Consumer>
        );
    }
}
